/**
 * Admin login screen. Only shown when no valid token in localStorage.
 * Single-admin system (no registration).
 */
import { useState } from "react";
import api, { setToken, extractErr } from "./api";

export default function AdminLogin({ onSuccess }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setToken(data.token);
            onSuccess?.(data.user);
        } catch (e) {
            setErr(extractErr(e, "Login fallito"));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center p-6" data-testid="admin-login">
            <form
                onSubmit={submit}
                className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl p-8 shadow-sm"
            >
                <div className="text-[10px] tracking-[0.28em] uppercase text-slate-500 mb-3">
                    Spazio Marconi · Admin
                </div>
                <h1 className="text-2xl font-semibold text-slate-900 mb-6">Accedi</h1>

                <label className="block text-xs font-medium text-slate-600 mb-1">Email</label>
                <input
                    type="email"
                    autoComplete="username"
                    className="w-full border border-slate-300 rounded-lg px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-slate-800/10"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    data-testid="admin-login-email"
                />

                <label className="block text-xs font-medium text-slate-600 mb-1">Password</label>
                <input
                    type="password"
                    autoComplete="current-password"
                    className="w-full border border-slate-300 rounded-lg px-3 py-2 mb-6 focus:outline-none focus:ring-2 focus:ring-slate-800/10"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    data-testid="admin-login-password"
                />

                {err && (
                    <div className="mb-4 text-xs text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="admin-login-error">
                        {err}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={busy}
                    className="w-full bg-slate-900 text-white rounded-lg py-2.5 text-sm font-medium hover:bg-slate-800 disabled:opacity-50 transition"
                    data-testid="admin-login-submit"
                >
                    {busy ? "Accesso in corso…" : "Entra"}
                </button>
            </form>
        </div>
    );
}
